import { Stack, Typography } from "@mui/material";
import CollectHeight from ".";

export default function HeightInputExamples() {
  const handleChange = (payload: { value: string; unit: string }) => {
    console.log(payload);
  };
  return (
    <>
      <Typography variant="h2">Height Input Example</Typography>
      <Stack sx={{ px: 2, mt: 1 }}>
        <CollectHeight onChange={handleChange} />
      </Stack>
    </>
  );
}
